import { debounce } from '@nodeModules/throttle-debounce';
import { initHeaderAuthForm } from './header-auth-form.js';
import { emailSpellCheckerPlugin } from './email-spell-checker.js';

export const initHeader = () => {
	initHeaderAuthForm();
	emailSpellCheckerPlugin();

	const $authListItem = document.querySelector('.js-auth-list-item');
    const $primaryList = document.querySelector('.js-primary-list');
    const $secondaryList = document.querySelector('.js-secondary-list');

    const matchMediaLarge = window.matchMedia(`screen and (min-width: 991px)`);

    if (!matchMediaLarge.matches) {
    	if ($authListItem && $primaryList) {
    		$primaryList.appendChild($authListItem);
    	}
    }

    const onWindowResize = function() {
    	if (matchMediaLarge.matches) {
    		$secondaryList.insertBefore($authListItem, $secondaryList.firstChild);
    	} else {
    		$primaryList.appendChild($authListItem);
    	}
    };

    const debouncedWindowResize = debounce(300, onWindowResize);

    window.addEventListener('resize', debouncedWindowResize);

    const $toggleNavigationCheckbox = document.querySelector('.js-toggle-navigation');
    const $navigationOverlay = document.querySelector('.js-navigation-overlay');

    if ($toggleNavigationCheckbox) {
    	$toggleNavigationCheckbox.addEventListener('change', event => {

    		if ($navigationOverlay) {
	    		if (event.target.checked) {
	    			document.querySelector('html').classList.add('with-open-mobile-navigation');
	    			$navigationOverlay.classList.add('site-header__overlay--is-active');
	    		} else {
	    			document.querySelector('html').classList.remove('with-open-mobile-navigation');
	    			$navigationOverlay.classList.remove('site-header__overlay--is-active');
	    		}
    		}
    	})
    }

    if ($navigationOverlay && $toggleNavigationCheckbox) {
    	$navigationOverlay.addEventListener('click', event => {
    		$toggleNavigationCheckbox.checked = false;
    		event.target.classList.remove('site-header__overlay--is-active');
    		document.querySelector('html').classList.remove('with-open-mobile-navigation');
    	})
    }

    const $toggleOrgNavigationCheckbox = document.querySelector('.js-toggle-org-navigation');
    const $toggleOrgNavigationLabel = document.querySelector('.js-toggle-org-navigation-label');
    const $orgNavigation = document.querySelector('.js-org-navigation');
    const $orgNavigationOverlay = document.querySelector('.js-org-navigation-overlay');

    if ($toggleOrgNavigationCheckbox) {
    	$toggleOrgNavigationCheckbox.addEventListener('change', event => {
    		if ($orgNavigationOverlay) {
    			if (event.target.checked) {
    				document.querySelector('html').classList.add('with-open-mobile-org-navigation');
    				$toggleOrgNavigationLabel.classList.add('active');
    				$orgNavigation.classList.add('is-open');
	    			$orgNavigationOverlay.classList.add('is-active');
				} else {
					document.querySelector('html').classList.remove('with-open-mobile-org-navigation');
    				$toggleOrgNavigationLabel.classList.remove('active');
    				$orgNavigation.classList.remove('is-open');
	    			$orgNavigationOverlay.classList.remove('is-active');
				}
			}
		})
    }

    if ($orgNavigationOverlay && $toggleOrgNavigationCheckbox) {
    	$orgNavigationOverlay.addEventListener('click', event => {
    		$toggleOrgNavigationCheckbox.checked = false;
    		$toggleOrgNavigationLabel.classList.remove('active');
    		$orgNavigation.classList.remove('is-open');
    		event.target.classList.remove('is-active');
    		document.querySelector('html').classList.remove('with-open-mobile-org-navigation');
    	})
    }

    const $toggleActions = document.querySelectorAll('.js-toggle-action');
    const $subLists = document.querySelectorAll('.js-sub-list');

    if ($toggleActions.length && $subLists.length) {
    	$toggleActions.forEach((toggleAction) => {
    		toggleAction.addEventListener('click', event => {
				event.stopPropagation();

				if (!matchMediaLarge.matches && event.target.dataset.redirectUrl) {
					window.location = event.target.dataset.redirectUrl;
				}

				if (event.target.nextElementSibling.classList.contains('is-shown')) {
					event.target.nextElementSibling.classList.remove('is-shown');
				} else {
					$subLists.forEach((subList) => {
			    		if (subList.classList.contains('is-shown')) {
			    			subList.classList.remove('is-shown');
			    		}
			    	})

					event.target.nextElementSibling.classList.add('is-shown');

					if (
						toggleAction.classList.contains('site-header__toggle-action--is-auth') &&
						typeof rescaleCaptcha === 'function'
					) {
						rescaleCaptcha();
					}
				}
			})
    	})
    }

    const $authToggleAction = document.querySelector('.js-auth-toggle-action');
	const $authList = document.querySelector('.js-auth-sub-list');

    if ($authToggleAction && $authList) {
    	$authToggleAction.addEventListener('click', event => {
    		event.stopPropagation();

    		if (!matchMediaLarge.matches && event.target.dataset.redirectUrl) {
				window.location = event.target.dataset.redirectUrl;
			}

    		$subLists.forEach((subList) => {
	    		if (subList.classList.contains('is-shown')) {
	    			subList.classList.remove('is-shown');
	    		}
	    	})

    		$authList.classList.add('is-shown');
    	})
    }

    const $forSellersToggleAction = document.querySelector('.js-for-sellers-toggle-action');
	const $forSellersList = document.querySelector('.js-for-sellers-sub-list');

	if ($forSellersToggleAction && $forSellersList) {
    	$forSellersToggleAction.addEventListener('click', event => {
    		event.stopPropagation();

    		$subLists.forEach((subList) => {
	    		if(subList.classList.contains('is-shown')) {
	    			subList.classList.remove('is-shown');	
	    		}
	    	})

    		$forSellersList.classList.add('is-shown');
    	})
    }
    
	window.addEventListener('click', event => {
    	if ($subLists.length) {
    		$subLists.forEach((subList) => {
	    		if(subList.classList.contains('is-shown')) {
	    			if (event.target.closest('.site-header__sub-list.is-shown') || event.target.closest('.input__suggestion')) {
                		return;
            		} else {
	    				subList.classList.remove('is-shown');	
            		}
	    		}
	    	})
    	}
	});

	document.querySelectorAll('.js-virtual-page-view').forEach(el => {
  		el.addEventListener('click', event => {
  			event.preventDefault();
  			const target = event.target;

	    	if (typeof dataLayer === 'undefined' && target.href) {
    			if (target.target === '_blank') {
					window.open(target.href, '_blank');
    			} else {
    				window.location = target.href;
    			}
	  		} else {
		  		dataLayer.push({
		    		'event': 'GTMPageview',
		    		'VirtualPageview': target.dataset.pageView,
		    		'VirtualPageviewTitle': target.dataset.pageViewTitle
		  		});

		  		if (target.href) {
	    			if (target.target === '_blank') {
						window.open(target.href, '_blank');
	    			} else {
	    				window.location = target.href;
	    			}
	    		}
	  		}
  		})
	})

	const $header = document.querySelector('.site-header');
	const $eventPublished = document.querySelector('.event_published');
	const $mobileOrgNavigation = document.querySelector('.org-navigation__nav');
	let $beamer = '';

    let prevScrollpos = window.pageYOffset;
	const zigZagBorderHeight = 10;

	window.addEventListener('scroll', function () {
		const currentScrollPos = window.pageYOffset;
		const headerHeight = $header.clientHeight;

		if (!$beamer) {
			$beamer = document.querySelector('.beamer_defaultBeamerSelector');
		}

		if (currentScrollPos > (headerHeight / 2)) {
		  	if (prevScrollpos > currentScrollPos) {
		    	$header.style.top = '0px';

		    	if ($eventPublished) {
		    		$eventPublished.style.top = `${headerHeight}px`;
		    	}

		    	if ($mobileOrgNavigation) {
		    		$mobileOrgNavigation.style.bottom = '0px';
		    	}

		    	if ($beamer) {
		    		$beamer.style.bottom = '85px';
		    	}
		  	} else {
		    	$header.style.top = `-${headerHeight + zigZagBorderHeight}px`;

		    	if ($eventPublished) {
		    		$eventPublished.style.top = '0px';
		    	}

		    	if ($mobileOrgNavigation) {
		    		$mobileOrgNavigation.style.bottom = `-${$mobileOrgNavigation.clientHeight}px`;
		    	}

		    	if ($beamer) {
	    			$beamer.style.bottom = '20px';
	    		}
		  	}

	  		prevScrollpos = currentScrollPos;
		} else {
			$header.style.top = '0px';

			if ($eventPublished) {
	    		$eventPublished.style.top = `${headerHeight}px`;
	    	}

	    	if ($mobileOrgNavigation) {
	    		$mobileOrgNavigation.style.bottom = '0px';
	    	}

	    	if ($beamer) {
	    		$beamer.style.bottom = '85px';
	    	}
		}
	}, false);
};
